export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.049 4c.3-.921 1.603-.921 1.902 0l1.614 4.969h5.225c.969 0 1.372 1.24.588 1.809l-4.227 3.07 1.615 4.97c.299.92-.755 1.687-1.54 1.118L12 16.865l-4.227 3.07c-.783.57-1.838-.196-1.539-1.117l1.615-4.97-4.227-3.07c-.784-.57-.38-1.81.588-1.81h5.224L11.05 4zM12 5.927l-1.251 3.85a1 1 0 01-.951.692h-4.05l3.276 2.38a1 1 0 01.364 1.118l-1.251 3.85 3.275-2.38a1 1 0 011.176 0l3.276 2.38-1.252-3.85a1 1 0 01.364-1.118l3.275-2.38h-4.049a1 1 0 01-.95-.691L12 5.927z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};